import { $contents } from '@/services/'
import { dateEST } from './injectables'

export default {
  _debounce (func, delay) {
    let debounceTimer
    return function () {
      const context = this
      const args = arguments
      clearTimeout(debounceTimer)
      debounceTimer = setTimeout(() => func.apply(context, args), delay)
    }
  },

  /**
   * prepare skeleton data for widgets, for pre-render
   * @param {*} dateObj must be in Date Object
   */
  prepareSkeletonData(dateObj){
    // Throw Uncaught exception if cannot find Date Object
    if (!(dateObj instanceof Date)) throw 'Date object expected!'
    const data = { months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'], data: [], labels: [] };   
    dateObj.setDate(1);
    var currentMonth = dateObj.getMonth();
    dateObj.setMonth(0);
    for (var i=0; i<=currentMonth; i++) {
      data.labels.push(data.months[dateObj.getMonth()] + ' ' + dateObj.getFullYear())
      data.data.push({
        month: dateObj.getMonth()+1,
        year: dateObj.getFullYear(),
        index: i
      })
      dateObj.setMonth(dateObj.getMonth() + 1);
    }
    return data;
  },

  getMonthIndex(currentDate, tempDataStore){
    if(currentDate){
      /**
       * Important : As currentDate param contatins only date. not time we don't required 
       * timezone here (If in future needs then update this function by condition)
       */
      let month = currentDate.split('-')[1];
      let year = currentDate.split('-')[0];
      var dataChunk = tempDataStore.data ? tempDataStore.data.filter( objM => objM.month == month && objM.year == year ) : {};
      let index = (typeof dataChunk[0] === 'object' && dataChunk[0].hasOwnProperty("index")) ? dataChunk[0].index : null;
      return index;
    }
    return null;
  },
  
  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },

  fetchContentPreview(dataObj, content_id, iframe_id) {
      $contents.preview(content_id, {params: dataObj,
        }).then(response => {
          const content_html = response.data.data.content.html_part
          var iframe = document.getElementById(iframe_id)
          iframe.width = '100%'
          var doc = iframe.contentWindow.document
          iframe.style.height = "0px"
          doc.open()
          doc.write(content_html)
          setTimeout(() => {
            doc.close()
            iframe.style.height = doc.body.scrollHeight + 'px'
          }, 2000)
      })
  },
  calculateTop (id,listData) {
    if(listData.length<5) return false
    return (
      listData.map(function (x) {
      return x.id
    }).indexOf(id) > listData.length-3)
  },
  enableAttach (id, listData){
    if(listData.length<5) return false
    return (
      listData.map(function (x) {
      return x.id
    }).indexOf(id) < listData.length-4)
  },
  isEmojiExist(value){
    if((/^(?:(?!(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff]))[^]){1,255}$/).test(value)) 
      return true;
      
    return false;
  },
  urlRule(message = "Invalid URL") {
    return v => {
      if (!v) return true;
      const pattern = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
      return pattern.test(v) || message;
    };
  },
  required(name, message) {
    return v => {
      message = message || `${name} is required`;
      if (typeof v === "string") {
        return (!!v && !!v.trim()) || message;
      } else if (typeof v === "string" && Array.isArray(v)) {
        return !!v.length || message;
      }
      return true;
    };
  },
  checkForEmoji(message = "You cannot use emojis in this field.") {
    return v => {
      if (!v) return true;
      return this.isEmojiExist(v) || message;
    };
  },
  maxLength(size, name, message) {
    return v => {
      message = message || `${name} should be less than ${size} characters.`;
      if (typeof v === "string") {
        return (!!v && !!v.trim() && v.length <= size) || message;
      }
      return true;
    };
  },
}
// commit to check push permissions
